import React from 'react'
import {connect} from 'react-redux'
import {Mask} from 'react-weui'
import ChimeePlayer from 'chimee-player';

import '../styles/VideoPlayer.css'
import '../styles/chimee/ChimeeVideo.css';
import '../styles/chimee/ChimeeMenu.css';
import '../styles/chimee/ChimeeCenterState.css';


class VideoPlayer extends React.Component {
    hide() {
        this.props.dispatch({
            type: 'HIDE_VIDEO_PLAYER'
        })
    }

    componentDidUpdate() {
        // 安卓和pc端加载新的视频播放器
        let elem = document.getElementById('chimee-container')
        let flag = this.props.videoPlayer.showVideoPlayer && this.props.videoPlayer.type === 'video'
            && window.systemType !== 'ios' && window.systemType !== 'android' && elem
        if (flag) {
            let chimeeOptions = {
                wrapper: '#chimee-container',
                src: this.props.videoPlayer.dataUrl,
                isLive: false,
                box: 'native',
                autoplay: true,
                preload: 'load',
                controls: true,
                xWebkitAirplay: true
            }
            new ChimeePlayer(chimeeOptions)
        }
    }

    render() {
        const {videoPlayer} = this.props

        if (!videoPlayer.showVideoPlayer)
            return null

        return <div className="video-player">
            <Mask onClick={this.hide.bind(this)}/>
            {videoPlayer.type === 'video' ?
                <div>
                    {(window.systemType !== 'ios' && window.systemType !== 'android') ?
                        <div id="chimee-container" className="chimee-container"
                             style={{height: '100%', width: '100%'}}>
                            <video tabIndex="-1" id="video-player"/>
                        </div>
                        :
                        <video is
                               id="normal-video"
                               className="normal-video"
                               x-webkit-airplay="true"
                               webkit-playsinline=""
                               playsinline="true"
                               preload="load"
                               src={videoPlayer.dataUrl}
                               controls
                               controlsList="nodownload"/>
                    }
                </div>
                :
                <iframe frameBorder="0" allowFullScreen src={videoPlayer.dataUrl}/>
            }
        </div>
    }
}


export default connect((state) => ({
    videoPlayer: state.videoPlayer
}))(VideoPlayer)




// WEBPACK FOOTER //
// ./src/components/VideoPlayer.js